let audioCtx: AudioContext | null = null;

interface CustomWindow extends Window {
  AudioContext?: typeof AudioContext;
  webkitAudioContext?: typeof AudioContext;
}

function initAudioContext(): void {
  try {
    const W = window as unknown as CustomWindow;
    const AudioCtxClass = W.AudioContext || W.webkitAudioContext;
    if (AudioCtxClass) {
      audioCtx = new AudioCtxClass();
    }
  } catch (e) {
    console.warn('Web Audio API is not supported in this environment:', e);
  }
}

function resumeAudioContext(): void {
  if (audioCtx && audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
}

export function primeAudio(): void {
  if (typeof window === 'undefined') return;
  if (!audioCtx) {
    initAudioContext();
  }
  resumeAudioContext();
}

function playOscillator(
  ctx: AudioContext,
  now: number,
  duration: number,
  type: OscillatorType,
  startFreq: number,
  endFreq: number,
  gainVal: number
): void {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  
  osc.type = type;
  osc.frequency.setValueAtTime(startFreq, now);
  osc.frequency.exponentialRampToValueAtTime(endFreq, now + duration);

  gain.gain.setValueAtTime(gainVal, now);
  gain.gain.linearRampToValueAtTime(0.0001, now + duration);

  osc.connect(gain);
  gain.connect(ctx.destination);

  osc.start(now);
  osc.stop(now + duration);
}

export function playLaunchSound(): void {
  if (typeof window === 'undefined') return;
  primeAudio();
  if (!audioCtx) return;

  const now = audioCtx.currentTime;
  const duration = 0.9;

  // Main Oscillator: Sine
  playOscillator(audioCtx, now, duration, 'sine', 220, 60, 0.4);

  // Secondary Oscillator: Triangle
  playOscillator(audioCtx, now, duration, 'triangle', 180, 40, 0.15);
}
